import { render, staticRenderFns } from "./ModalRenameContact.vue?vue&type=template&id=0c4bbcfe&scoped=true"
import script from "./ModalRenameContact.vue?vue&type=script&lang=js"
export * from "./ModalRenameContact.vue?vue&type=script&lang=js"
import style0 from "./ModalRenameContact.vue?vue&type=style&index=0&id=0c4bbcfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4bbcfe",
  null
  
)

export default component.exports